import { render, staticRenderFns } from "./SpecialList.vue?vue&type=template&id=6389dc4e&scoped=true&"
import script from "./SpecialList.vue?vue&type=script&lang=js&"
export * from "./SpecialList.vue?vue&type=script&lang=js&"
import style0 from "./SpecialList.vue?vue&type=style&index=0&id=6389dc4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6389dc4e",
  null
  
)

export default component.exports